import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';
import { ReactFormFieldList } from './reactformfieldlist';

export class ReactFormMultipleDocuments extends PureComponent {
    constructor(props) {
        super(props);
        this.handleAddDocument = this.handleAddDocument.bind(this);
        this.handleDeleteDocument = this.handleDeleteDocument.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleHideMode = this.handleHideMode.bind(this);
        this.handleEditMode = this.handleEditMode.bind(this);
        this.handleExitEditMode = this.handleExitEditMode.bind(this);
        this.handleEditDocument = this.handleEditDocument.bind(this);

        this.state = {           
            inputValues: {},
            hideMode: true, 
            editMode: false,
            currentEditedDocument: ''      
        };
    }

    handleInputChange(newDoc) {
        this.setState({ inputValues: newDoc });
    }
    
    handleAddDocument() {
        let documents = [...this.props.value];
        if (this.props.value) {
            documents.push(this.state.inputValues);
        }
        else {
            documents = [this.state.inputValues];
        }

        if(this.props.onChange)
            this.props.onChange(documents);

        this.setState({inputValues: {}, hideMode: true});
    }

    handleEditDocument() {
        let documents = [...this.props.value];
        documents[this.state.currentEditedDocument] = this.state.inputValues;
        if(this.props.onChange)
            this.props.onChange(documents);
        this.setState({inputValues: {}, editMode: false, hideMode: true});
    }

    handleDeleteDocument(index) {
        let documents = [...this.props.value];
        documents.splice(index, 1);
            if(this.props.onChange)
                this.props.onChange(documents);         
    }

    handleHideMode() {
        this.setState(prevState => ({
            hideMode: !prevState.hideMode
        }));
    }

    handleEditMode(index) {
        let selectedDocument = this.props.value[index];     
        this.setState({inputValues: selectedDocument, hideMode: false, editMode: true, currentEditedDocument: index});
    }

    handleExitEditMode() {
        this.setState({inputValues: {}, editMode: false, hideMode: true});
    }

    render() {
        const MultipleDocumentsView = this.props.viewProvider.getMultipleDocumentsView();
        const editModeButtonText = !this.state.editMode ? "Ajouter" : "Sauvegarder les modifications";
        const actionOnCancel = !this.state.editMode ? this.handleHideMode : this.handleExitEditMode;
        const actionOnSubmit = !this.state.editMode ? this.handleAddDocument : this.handleEditDocument;
        const name = this.props.isMultilingual ? this.props.name[this.props.lang] : this.props.name;

        let hideModeButtonText;
        if (this.state.hideMode)
            hideModeButtonText = "Ajouter";
        else if (this.state.editMode)
            hideModeButtonText = "Annuler les modifications";
        else 
            hideModeButtonText = "Fermer les champs";

        return (
            <ReactFormGroupWrapper {...this.props}>       
                
           
                <ReactFormFieldList 
                    fields={this.props.fields} 
                    formValues={this.state.inputValues}
                    validationErrors={this.props.validationErrors} 
                    onChange={this.handleInputChange}                     
                    viewProvider={this.props.viewProvider}
                    display={!this.state.hideMode}
                    indentation={this.props.indentation}
                    isMultilingual={this.props.isMultilingual}
                    lang={this.props.lang}
                />                                                      
                
                <MultipleDocumentsView
                    name={name}
                    value={this.props.value}
                    inputValues={this.state.inputValues}
                    onChange={this.handleAddDocument} 
                    onInputChange={this.handleInputChange}
                    onEdit={this.handleEditMode}
                    onDelete={this.handleDeleteDocument}
                    fields={this.props.fields}
                    hideMode={this.state.hideMode}
                    handleHideMode={this.handleHideMode}
                    editMode={this.state.editMode}
                    applyChanges={this.handleEditDocument}
                    editModeButtonText={editModeButtonText}
                    hideModeButtonText={hideModeButtonText}
                    actionOnSubmit={actionOnSubmit}
                    actionOnCancel={actionOnCancel}
                    previewFields={this.props.previewFields}
                    isMultilingual={this.props.isMultilingual}
                    lang={this.props.lang}
                    isInvalid={this.props.showValidationErrors}
                />
            </ReactFormGroupWrapper>
        );
    }
}
ReactFormMultipleDocuments.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    validationErrors: PT.any,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    fields: PT.array,
    previewFields: PT.array,
    indentation: PT.number,
    isMultilingual: PT.bool,
    lang: PT.string
};

ReactFormMultipleDocuments.defaultProps = {
    value: "" 
};
